<template>
  <div class="position-relative">
    <div
      v-if="loading"
      class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center rounded"
      :style="{
        backgroundColor: 'rgba(193, 193, 193,' + opacity / 100 + ')',
        boxShadow: 'inset 0 0 0 10px rgba(193, 193, 193, 0.5)'
      }"
      style="z-index: 1045"
    >
      <div class="spinner-border text-primary position-sticky sticky-top" role="status">
        <span class="sr-only visually-hidden">Chargement...</span>
      </div>
    </div>
    <slot name="default"> </slot>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    },

    opacity: {
      type: Number,
      default: 60,
      required: false,
      validator: (value) => {
        return value >= 0 && value <= 100
      }
    }
  }
}
</script>
